import useSWR from 'swr';
import { AccountType, SystemRole } from '../types';

export interface SystemRoleAccount {
    id: number;
    number: string;
    name: string;
    type: AccountType | null;
    needs_review?: boolean;
}

export interface SystemRoleRow {
    role: SystemRole;
    label: string;
    required: boolean;
    preset: { number: string; name: string; type: AccountType };
    account: SystemRoleAccount | null;
    adoptable_account: Omit<SystemRoleAccount, 'needs_review'> | null;
}

export interface SystemRoleOverview {
    mandant_id: number | null;
    skr: string | null;
    complete: boolean;
    roles: SystemRoleRow[];
}

export const systemRolesKey = (clubSlug?: string | null, mandantId?: number | null) =>
    clubSlug ? `invoice/${clubSlug}/account/system-roles${mandantId ? `?mandant_id=${mandantId}` : ''}` : null;

export const useSystemRoles = (clubSlug?: string | null, mandantId?: number | null, enabled = true) =>
    useSWR<{ data: SystemRoleOverview }>(enabled ? systemRolesKey(clubSlug, mandantId) : null);

export const useLedgerSetup = (clubSlug: string, mandantId?: number | null, enabled = true) => {
    const { data, isLoading, error } = useSystemRoles(clubSlug, mandantId, enabled);
    const overview = data?.data;

    return {
        hasSetup: !!overview?.complete,
        hasMandant: !!overview?.mandant_id,
        // A failed read is no proof of a missing setup, so the banner stays hidden instead of nagging.
        isLoading: !enabled || isLoading || (!overview && !!error),
        overview
    };
};
